export default "__VITE_ASSET__p89d9ywn__"